const initialState = {
  enhancedSales: null,
  enhancedSalesLoading: false,
  enhancedSalesError: null,

  enhancedPurchase: null,
  enhancedPurchaseLoading: false,
  enhancedPurchaseError: null,

  enhancedLedger: null,
  enhancedLedgerLoading: false,
  enhancedLedgerError: null,

  enhancedStock: null,
  enhancedStockLoading: false,
  enhancedStockError: null
};

const ReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ENHANCED_SALES_REQUEST':
      return { ...state, enhancedSalesLoading: true, enhancedSalesError: null };
    case 'FETCH_ENHANCED_SALES_SUCCESS':
      return { ...state, enhancedSalesLoading: false, enhancedSales: action.payload };
    case 'FETCH_ENHANCED_SALES_FAILURE':
      return { ...state, enhancedSalesLoading: false, enhancedSalesError: action.payload };

    // Enhanced Purchase Report
    case 'FETCH_ENHANCED_PURCHASE_REQUEST':
      return { ...state, enhancedPurchaseLoading: true, enhancedPurchaseError: null };
    case 'FETCH_ENHANCED_PURCHASE_SUCCESS':
      return { ...state, enhancedPurchaseLoading: false, enhancedPurchase: action.payload };
    case 'FETCH_ENHANCED_PURCHASE_FAILURE':
      return { ...state, enhancedPurchaseLoading: false, enhancedPurchaseError: action.payload };

    // Enhanced Ledger Report
    case 'FETCH_ENHANCED_LEDGER_REQUEST':
      return { ...state, enhancedLedgerLoading: true, enhancedLedgerError: null };
    case 'FETCH_ENHANCED_LEDGER_SUCCESS':
      return { ...state, enhancedLedgerLoading: false, enhancedLedger: action.payload };
    case 'FETCH_ENHANCED_LEDGER_FAILURE':
      return { ...state, enhancedLedgerLoading: false, enhancedLedgerError: action.payload };

    // Enhanced Stock Report
    case 'FETCH_ENHANCED_STOCK_REQUEST':
      return { ...state, enhancedStockLoading: true, enhancedStockError: null };
    case 'FETCH_ENHANCED_STOCK_SUCCESS':
      return { ...state, enhancedStockLoading: false, enhancedStock: action.payload };
    case 'FETCH_ENHANCED_STOCK_FAILURE':
      return { ...state, enhancedStockLoading: false, enhancedStockError: action.payload };

    default:
      return state;
  }
};

export default ReportsReducer;
